// extracted by mini-css-extract-plugin
var _1 = "ComparePostsView-module__animatedBackground--Ewb5B";
var _2 = "ComparePostsView-module__container--Js2KX";
var _3 = "ComparePostsView-module__editorContainer--wYmgN";
var _4 = "ComparePostsView-module__editorRoot--ZtnbX";
export { _1 as "animatedBackground", _2 as "container", _3 as "editorContainer", _4 as "editorRoot" }
